import React from "react";
import { Content } from "../pages/Template";
import styled from "styled-components";
import { device } from "../helpers/style";

const Container = styled.div`
    margin: 40px auto 0 auto;
    padding: 0 20px;
    width: 500px;
    color: #000;

    @media ${device.phone} {
        width: 100%;
    }
`;

const Heading = styled.div`
    margin-bottom: 30px;
    font-size: 24px;
`;
const List = styled.ol`
    font-size: 16px;
    padding-right: 15px;
`;
const Item = styled.li`
    font-size: 18px;
    margin-bottom: 20px;

    [lang="ar"] {
        margin: 0 5px;
        font-size: 16px;
    }
`;

export class TermsPage extends React.Component {
    static paths = ["/app/terms"];

    render() {
        return (
            <Content>
                <Container>
                    <Heading>اصول</Heading>
                    <List>
                        <Item>
                            قرآن پاک کے بارے میں کسی قسم کا مزاق قابل قبول
                            نہیں۔
                        </Item>
                        <Item>
                            محمد رسول اللہ
                            <span lang="ar">ﷺ</span>
                            کی ختم نبوت پر سوال یا اُن کے متعلق کچھ بھی گستاخانہ
                            ہرگز قابل قبول نہیں۔
                        </Item>
                        <Item>
                            تمام انبیا و رسول جن کی تعظیم کا حکم ہمیں رسول
                            <span lang="ar">ﷺ</span>
                            نے سکھایا ہے اُن کے متعلق کسی قسم کی تضحیک قابل قبول
                            نہیں۔
                        </Item>
                        <Item>
                            اسلام اور پاکستان کے خلاف کسی قسم کی بات قابل برداشت
                            نہیں۔
                        </Item>
                        <Item>
                            صرف اُردو رسم الخط میں تحریر کی اشاعت کی جائے گی۔
                        </Item>
                        <Item>
                            کسی دوسرے سے تحریر چوری کر کے اپنے نام سے شائع مت
                            کرنا۔
                        </Item>
                        <Item>
                            فحش مواد یا جس سے کسی قسم کا فساد پھیلے وہ قابل قبول
                            نہیں۔
                        </Item>
                    </List>
                </Container>
            </Content>
        );
    }
}
